import React, { useEffect, useState } from 'react'
import WarningWorkflowProcess from '../warningWorkflowProcessComp/WarningWorkflowProcess';
import { useSearchParams } from 'react-router-dom';

const AckEW = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [searchParams] = useSearchParams();
    const getToken = searchParams.get("token")

    const [warningId, setWarningId] = useState<string>('')
    const [username, setUsername] = useState<string>('')
    const [warningType, setWarningType] = useState<string>('')

    useEffect(() => {
    if (!getToken) return;

    console.log(">>>>>>>>>> TOKEN: ", getToken)
    fetch(`${BASE_URL}/identity_manager/api/v1/jwt-details?token=${getToken}`)
        .then(res => {
            if (!res.ok) throw new Error('Failed to fetch token details');
            return res.json();
        })
        .then(data => {
            if (data.warningId && data.username && data.warningType) {
                setWarningId(data.warningId);
                setUsername(data.username)
                setWarningType(data.type)
                //console.log(">>>>>>>>>> Data CLAIMS: ", data)
            } else {
                //console.warn('warningId not found in response:', data);
            }
        })
        .catch(err => {
            console.error('Error fetching token details:', err);
        });
    }, [getToken])
    

    return (
        <div className='accept-external-ew App colorful'>
            <div className='container' style={{backgroundColor: '#ffffffff', border: 'solid 0.1rem gray'}}>
                <WarningWorkflowProcess type='ACK' id={warningId} token={getToken!} catMType={warningType} currentUser={username}/>
            </div>
        </div>
    )
}

export default AckEW